import styles from './ProfileCard.module.scss';
import { withRouter } from 'react-router-dom';
import IGenericResult from '../../interfaces/IGenericResult';
import { ILatLng } from '../map/Map';
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { getCurrentPosition } from '../../lib/util';
import GenericButton from '../generic-button/GenericButton';
import { MapMarkerIcon, PrintIcon, ProfileIcon } from '../icons/Icons';
import { AppContext } from '../../context/AppContext';
import { IAppContext, defaultAppState } from '../../context/DefaultAppState';
import IOrigin from '../../interfaces/IOrigin';

const ProfileCard = (props: any) => {
  const appContext = useContext(AppContext);
  const { recordId, name, specialty, phone, addressLine1, addressLine2, city, state, zipCode, acceptingNewPatients, approximateDistance, serviceMode } = props.result as IGenericResult;
  const [directions, setDirections] = useState<google.maps.DirectionsResult>();
  const [miles, setMiles] = useState('');



  /* useEffect(() => {
    getDistanceForProfile(addressLine1, addressLine2, setMiles, setDirections, props.planState);
  }, [addressLine1, addressLine2]); */

  const handleProfileClick = (passedProps: any) => {
    const { planCode, directory} = passedProps.match.params;
    passedProps.history.push(`/profile/${planCode}/${recordId}/${directory}?directions=false`);
  };

  const handleProfileDirectionsClick = (passedProps: any) => {
    const { planCode, directory} = passedProps.match.params;
    passedProps.history.push(`/profile/${planCode}/${recordId}/${directory}?directions=true`);
  };

  return (
    <div className={styles.profileCard}>
      <div className={styles.miles}>
        {/* miles to approximateDistance */}
        <p>{typeof approximateDistance === 'undefined' || approximateDistance === null ? '' : `${approximateDistance} mi`}</p>
        <p>{typeof acceptingNewPatients === 'undefined' ? '' : `Accepting New Patients: ${acceptingNewPatients}`}</p>
		<p>{typeof serviceMode === 'undefined' ? '' : `Service Mode: ${serviceMode}`}</p>
	  </div>
      <p className={styles.name}>
        {`${props.profileCardIndex + 1}. `} {name}
      </p>
      <p className={styles.subInformation}>{specialty}</p>
      <p className={styles.subInformation}>{addressLine1}</p>
      {addressLine2 ? <p className={styles.subInformation}>{addressLine2}</p> : null}
      <p className={styles.subInformation}>{city}, {state} {zipCode}</p>
      <p className={styles.phone}>{phone}</p>

      <div className={styles.cardButtonContainer}>
        <GenericButton buttonText={'View Profile'} handleClick={() => handleProfileClick(props)}>
          <ProfileIcon/>
        </GenericButton>
        <GenericButton buttonText={'Get Directions'} handleClick={() => handleProfileDirectionsClick(props)}>
          <MapMarkerIcon/>
        </GenericButton>
        <p>Click Profile for other service locations</p>
      </div>
    </div>
  );
};

const getDistanceForProfile = (
  address1: string,
  address2: string,
  setMiles: React.Dispatch<React.SetStateAction<string>>,
  setDirections: React.Dispatch<React.SetStateAction<google.maps.DirectionsResult | undefined>>,
  planState: string,
) => {
  (async () => {
    //let firstPass = true
    try {
      let currentLocation = { lat: 0, lng: 0 };

      /* if (origin !== defaultAppState.origin) {
        currentLocation.lat = origin.lat;
        currentLocation.lng = origin.lng;
        console.log(origin);
      } else {
        const res: any = await getCurrentPosition();
        const { latitude, longitude } = res;
        currentLocation.lat = latitude;
        currentLocation.lng = longitude;
      } */

      //console.log(currentLocation);

      let distance: string = 'N/A';
      /* if (process.env.REACT_APP_MAPS_API_KEY && origin !== defaultAppState.origin) {
        const formattedAddress = `${address1} ${address2}`.split(' ').join('+');
        console.log(formattedAddress);
        const geocode = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${formattedAddress}&key=${process.env.REACT_APP_MAPS_API_KEY}`);
        const locationToMark: { lat: number; lng: number } = geocode.data.results[0].geometry.location;
        getDirections(currentLocation, locationToMark, setDirections);
        distance = getDistance(currentLocation, locationToMark);
      }
      setMiles(distance); */
      //firstPass = false;
    } catch (err) {
      console.error(err);
    }
    /* if (firstPass) {
      try {
        let currentLocation = { lat: 0, lng: 0 };
        //let planLocation: any;
        const address = `${planState}`.split(' ').join('+');
        const geoCurrentLocation = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${process.env.REACT_APP_MAPS_API_KEY}`);
        //planLocation = geocode.data.results[0]?.geometry?.location;
  
        const { latitude, longitude } = geoCurrentLocation.data.results[0]?.geometry?.location;;
        currentLocation.lat = latitude;
        currentLocation.lng = longitude;
        let distance: string = 'N/A';
        if (process.env.REACT_APP_MAPS_API_KEY) {
          const formattedAddress = `${address1} ${address2}`.split(' ').join('+');
          const geocode = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${formattedAddress}&key=${process.env.REACT_APP_MAPS_API_KEY}`);
          const locationToMark: { lat: number; lng: number } = geocode.data.results[0].geometry.location;
          getDirections(currentLocation, locationToMark, setDirections);
          distance = getDistance(currentLocation, locationToMark);
        }
        setMiles(distance);
      } catch (err) {
        console.error(err);
      }
    } */
  })();
};

const rad = (x: number) => {
  return (x * Math.PI) / 180;
};

const getMiles = (meters: number) => {
  return (meters * 0.000621371192).toFixed(2);
};

//Distance between two Lat Lng points
const getDistance = (p1: ILatLng, p2: ILatLng): string => {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(p2.lat - p1.lat);
  var dLong = rad(p2.lng - p1.lng);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return getMiles(d); // returns the distance in meter
};

const getDirections = (origin: any, destination: any, setDirections: React.Dispatch<React.SetStateAction<google.maps.DirectionsResult | undefined>>) => {
  const DirectionsService = new google.maps.DirectionsService();

  DirectionsService.route(
    {
      origin: new google.maps.LatLng(origin.lat, origin.lng),
      destination: new google.maps.LatLng(destination.lat, destination.lng),
      travelMode: google.maps.TravelMode.DRIVING
    },
    (result, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        setDirections(result);
      } else {
        console.error(`error fetching directions ${result}`);
        return {
          geocoded_waypoints: [],
          routes: []
        };
      }
    }
  );
};

export default withRouter(ProfileCard);
